import BlogNewsComponent from "../components/blognewscomponents/blognewscomponent"

const BlogNewsPage =()=>{

    return(
        <BlogNewsComponent/>
    )
    
}
export default BlogNewsPage